import $ from 'jquery';
import 'jquery-mousewheel';
require('malihu-custom-scrollbar-plugin')($);
import _ from 'underscore';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-select',
			dom: {
				value: '.js-select-value',
				input: '.js-select-input',
				current: '.js-select-current',
				dropdown: '.js-select-dropdown',
				list: '.js-select-list',
				item: '.js-select-item',
				template: '.js-select-template'
			},
			classes: {
				direction: {
					up: 'b-select_direction_up'
				},
				state: {
					open: 'b-select_state_open'
				},
				item: {
					state: {
						active: 'b-select__item_state_active',
						hidden: 'b-select__item_state_hidden'
					}
				}
			},
			size: {
				height: 34,
				count: 7
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$document = $(document);
		return this;
	}

	setOptions(options) {
		this.$list.html(this.template({list: options}));
		this.$items = this.$list.find(this.options.dom.item);
		return this;
	}

	getDom() {
		this.$value = this.$el.find(this.options.dom.value);
		this.$input = this.$el.find(this.options.dom.input);
		this.$current = this.$el.find(this.options.dom.current);
		this.$dropdown = this.$el.find(this.options.dom.dropdown);
		this.$list = this.$el.find(this.options.dom.list);
		this.$items = this.$el.find(this.options.dom.item);
		this.$template = this.$el.find(this.options.dom.template);
		this.template = _.template(this.$template.html().trim());
		return this;
	}

	setValue(val) {
		const self = this;
		const value = val;
		const lastValue = self.$value.val();

		let find = false;

		self.$items.each(function () {
			const $this = $(this);
			const option = $this.data('value');
			if (option == value) {
				find = {
					value: option,
					text: $this.text()
				};
				self.$input.val(find.text);
				self.$current.text(find.text);
				self.$value.val(find.value).trigger('change');
				$this.addClass(self.options.classes.item.state.active);
			} else {
				$this.removeClass(self.options.classes.item.state.active);
			}
		});

		if (find !== false && lastValue !== find.value) {
			self.$el.trigger('yota.select.change', find);
		}
		return self;
	}

	close($active = false) {
		this.$el.removeClass(this.options.classes.state.open);
		if ($active !== false) {
			this.setValue($active.data('value'));
		}
		this.$el.trigger('yota.select.close');
		return this;
	}

	clear() {
		const isClear = this.$input.val() ? this.$input.val().trim() === '' : false;
		this.filter('', true);
		this.$input.val('');
		this.$value.val('').trigger('change');
		if (!isClear) {
			this.$el.trigger('yota.select.clean');
		}
		return this;
	}

	open() {
		this.$el.addClass(this.options.classes.state.open);
		this.$dropdown.data('position', 0);
		const $active = this.getActive();
		if ($active !== false) {
			this.scrollToItem($active);
		}
		this.$el.trigger('yota.select.open');
		// TODO: Direction top
		return this;
	}

	filter(key, open = false) {
		const self = this;
		const filter = key.toLowerCase().replace(/ё/g, 'е');

		if (filter.length) {
			let visibleCount = 0;
			self.$items.each(function () {
				const $item = $(this);
				const text = $item.text().toLowerCase().replace(/ё/g, 'е');
				const hide = text.indexOf(filter) < 0;
				visibleCount += hide ? 0 : 1;
				$item.toggleClass(self.options.classes.item.state.hidden, hide);
			});
			if (visibleCount === 0) {
				self.$items.removeClass(self.options.classes.item.state.hidden);
			}
		} else {
			self.$items.removeClass(this.options.classes.item.state.hidden);
		}
		if (!open) {
			const $active = self.$items.filter(':not(.' + self.options.classes.item.state.hidden + ')').eq(0);
			self.$items.not($active).removeClass(self.options.classes.item.state.active);
			$active.addClass(self.options.classes.item.state.active);
			self.$dropdown.mNCustomScrollbar('scrollTo', 0);
		}
		return self;
	}

	getActive() {
		const $visible = this.$items.filter(':not(.' + this.options.classes.item.state.hidden + ')');
		const $active = $visible.filter('.' + this.options.classes.item.state.active).eq(0);
		this.$items.not($active).removeClass(this.options.classes.item.state.active);
		if (!$active.length) {
			$visible.first().addClass(this.options.classes.item.state.active);
			return false;
		}
		return $active;
	}

	scrollToItem($active) {
		const itemHeight = $active.outerHeight(true);
		const itemTop = $active.position().top;
		const scrollTop = this.$dropdown.data('position');
		const scrollHeight = this.$dropdown.outerHeight(true);
		let scrollTo = false;

		if (itemTop < scrollTop) {
			scrollTo = itemTop;
		}

		if (itemTop + itemHeight - scrollHeight > scrollTop) {
			scrollTo = itemTop + itemHeight - scrollHeight;
		}

		if (scrollTo !== false) {
			this.$dropdown.mNCustomScrollbar('scrollTo', scrollTo);
		}

		return this;
	}

	moveActive(direction) {
		const $active = this.getActive();
		if ($active !== false) {
			let $set = $active[direction ? 'nextAll' : 'prevAll'](this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')').eq(0);
			if (!$set.length) {
				$set = this.$items.filter(this.options.dom.item + ':not(.' + this.options.classes.item.state.hidden + ')')[direction ? 'first' : 'last']();
			}
			this.$items.not($set).removeClass(this.options.classes.item.state.active);
			$set.addClass(this.options.classes.item.state.active);
			this.scrollToItem($set);
		}
		return this;
	}

	selectActive() {
		const $active = this.getActive();
		if ($active !== false) {
			this.close($active);
			this.$input.blur();
		}
		return this;
	}

	onInput(event) {
		const code = event.which;
		const codeUp = code === 38;
		const codeDown = code === 40;
		const codeEnter = code === 13;

		if (codeUp || codeDown || codeEnter) {
			event.preventDefault();
			if (codeEnter) {
				this.selectActive();
			} else {
				this.moveActive(codeDown);
			}
		} else {
			const filter = this.$input.val().trim();
			this.filter(filter);
		}
	}

	onFocusIn() {
		this
			.clear()
			.open();
	}

	onCurrent() {
		if (this.$el.hasClass(this.options.classes.state.open)) {
			this.close();
		} else {
			this.open();
		}
	}

	onClick(event) {
		const $target = $(event.currentTarget);
		this.$items.not($target).removeClass(this.options.classes.item.state.active);
		$target.addClass(this.options.classes.item.state.active);
		this.close($target);
	}

	onDocumentClick(event) {
		const $target = $(event.target);
		if (this.$el.hasClass(this.options.classes.state.open)) {
			if (!$target.is(this.$el) && !$target.closest(this.$el).length) {
				this
					.clear()
					.close();
			}
		}
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.$el.each(function () {
				self.getDom();

				self.$dropdown.mNCustomScrollbar({
					autoDraggerLength: false,
					mouseWheel: {
						enable: true,
						preventDefault: true
					},
					contentTouchScroll: self.options.size.height * 2,
					mouseWheelPixels: self.options.size.height * 2,
					scrollButtons: false,
					scrollInertia: self.options.size.height * self.options.size.count,
					theme: '',
					callbacks: {
						onCreate: function () {
							self.$dropdown.data('position', 0);
						},
						onUpdate: function () {
							if (this.mNCs) {
								self.$dropdown.data('position', this.mNCs.top < 0 ? -this.mNCs.top : 0);
							}
						},
						whileScrolling: function () {
							self.$dropdown.data('position', this.mNCs.top < 0 ? -this.mNCs.top : 0);
						}
					}

				});

				self.$el
					.on('click.select', self.options.dom.current, self.onCurrent.bind(self))
					.on('focusin.select', self.options.dom.input, self.onFocusIn.bind(self))
					.on('input.select paste.select keydown.select', self.options.dom.input, self.onInput.bind(self))
					.on('click.select', self.options.dom.item, self.onClick.bind(self))
					.on('yota.select.clear', self.clear.bind(self));

				self.$document.on('click.select', self.onDocumentClick.bind(self));
			});
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/select/select.js